
import { Injectable } from '@angular/core';

@Injectable()
export class DataModelService {
    constructor() { }

    public purchaseAmount: number;

}